import { SVGProps } from "react";

export function GoogleMeet(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1.2em"
      viewBox="0 0 37 31"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_401_3605)">
        <path
          d="M21.291 15.7771L24.8162 19.8066L29.5569 22.8358L30.3816 15.8026L29.5569 8.92798L24.7254 11.589L21.291 15.7771Z"
          fill="#00832D"
        />
        <path
          d="M0.834961 22.1812V28.1745C0.834961 29.543 1.94576 30.6541 3.31449 30.6541H9.30781L10.5488 26.1257L9.30781 22.1812L5.19597 20.9402L0.834961 22.1812Z"
          fill="#0066DA"
        />
        <path
          d="M9.30781 0.900146L0.834961 9.37299L5.19625 10.6111L9.30781 9.37299L10.5262 5.48221L9.30781 0.900146Z"
          fill="#E94235"
        />
        <path
          d="M0.834961 22.1835H9.30766V9.37256H0.834961V22.1835Z"
          fill="#2684FC"
        />
        <path
          d="M34.9702 4.4877L29.5576 8.92809V22.8357L34.9926 27.2934C35.8062 27.9307 36.9964 27.3499 36.9964 26.3156V5.44567C36.9964 4.39998 35.7778 3.82198 34.9701 4.48784"
          fill="#00AC47"
        />
        <path
          d="M21.2902 15.7773V22.1814H9.30664V30.6543H27.0767C28.4454 30.6543 29.5561 29.5432 29.5561 28.1747V22.836L21.2902 15.7773Z"
          fill="#00AC47"
        />
        <path
          d="M27.0767 0.900146H9.30664V9.37299H21.2902V15.7771L29.5562 8.92777V3.37982C29.5562 2.01109 28.4454 0.900288 27.0767 0.900288"
          fill="#FFBA00"
        />
      </g>
      <defs>
        <clipPath id="clip0_401_3605">
          <rect
            width="36.1604"
            height="29.8041"
            fill="white"
            transform="translate(0.834961 0.900146)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
